<article class="product-card d-flex flex-column h-100 bg-white">
  <div class="product-card__header mb-2">
    <h3 *scText="title()" class="product-card__header--title mt3"></h3>
    @if (showContent() && content(); as content) {
      <div *scText="content"></div>
    }
  </div>

  @if (image(); as cardImage) {
    <figure
      class="product-card__image-container w-100 overflow-hidden m-0 mb-2"
    >
      <picture>
        <img *scImage="cardImage" class="w-100 h-100 object-fit-cover" />
      </picture>
    </figure>
  }

  @if (showDetails() && details(); as details) {
    <wl-rich-text-wrapper
      class="d-flex flex-column flex-grow-1"
      [field]="details"
    >
      <div class="product-card__content text-break mb-2"></div>
    </wl-rich-text-wrapper>
  }
  <div class="product-card__footer d-flex flex-column">
    @if (showCost() && cost(); as cost) {
      <p>
        <span class="product-card__cost"
          >Vanaf €<span *scText="cost" class="product-card__cost-text"></span
          >,- </span
        >(excl. BTW)<br />
        <span *scText="costAddition()!"></span>
      </p>
    }
    <crnt-button-alt
      variant="primary"
      [fullWidth]="true"
      wlTrackLink
      [trackLinkInfo]="{
        rendering: { componentName: 'ProductCardComponent' },
        field: button1()?.value?.text || '',
        eventType: 'button-click',
        type: 'button',
      }"
    >
      <a *wlGenericLink="button1()"></a>
    </crnt-button-alt>

    @if (showSecondButton()) {
      <crnt-button-alt
        variant="tertiary"
        [fullWidth]="true"
        class="mt-2"
        wlTrackLink
        [trackLinkInfo]="{
          rendering: { componentName: 'ProductCardComponent' },
          field: button2()?.value?.text || '',
          eventType: 'button-click',
          type: 'button',
        }"
      >
        <a *wlGenericLink="button2()!"></a>
      </crnt-button-alt>
    }
  </div>
</article>
